import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/conciliacao-bancaria/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;
const pathDocumentsHub = process.env.REACT_APP_URL_API_DOC_HUB;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const uploadOfx = async ({
  empresa_cnpj,
  body,
  empresa_id,
  usuario_id,
}) =>
  search(
    `${path}/ofx/processar?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}&usuario_id=${usuario_id}`,
    "POST",
    headers,
    body
  );

export const markTransactionAsPending = async ({ empresa_cnpj, body }) =>
  search(
    `${path}/ofx/marcar-pendente?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );

export const ignoreTransaction = async ({ empresa_cnpj, body }) =>
  search(
    `${path}/ofx/ignorar-transacao?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );

export const confirmConciliations = async ({ empresa_cnpj, body }) =>
  search(
    `${path}/ofx/confirmar-conciliacao?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );

export const cancelPendingConciliation = async ({ empresa_cnpj, body }) =>
  search(
    `${path}/ofx/cancelar-conciliacao?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );

export const pedingConciliation = async ({
  empresa_cnpj,
  file_ofx_id,
  empresa_id,
}) =>
  search(
    `${path}/ofx/conciliacao-aberta?empresa_cnpj=${empresa_cnpj}&arquivo_ofx_id=${file_ofx_id}&empresa_id=${empresa_id}`,
    "GET",
    headers
  );

export const openFinanceConciliation = async ({
  empresa_cnpj,
  agencia_id,
  start_date,
  end_date,
  empresa_id,
}) =>
  search(
    `${path}/ofx/conciliacao-aberta?empresa_cnpj=${empresa_cnpj}&agency_id=${agencia_id}&initial_date=${start_date}&end_date=${end_date}&empresa_id=${empresa_id}`,
    "GET",
    headers
  );

export const getQyonOfx = async ({
  empresa_cnpj,
  agencia_id,
  empresa_id,
  dataInicio,
  dataFim,
}) =>
  search(
    `${path}/ofx/get-bank-ofx?empresa_cnpj=${empresa_cnpj}&agencia_id=${agencia_id}&empresa_id=${empresa_id}&dataInicio=${dataInicio}&dataFim=${dataFim}`,
    "GET",
    headers
  );

export const getHistoric = async ({
  empresa_cnpj,
  empresa_id,
  agencia_id,
  type,
  status,
  data_start,
  data_end,
}) => {
  let searchDate = "";
  if (data_start && data_end) {
    searchDate = `&data_start=${data_start}&data_end=${data_end}`;
  }

  let searchStatus = "";
  if (status) {
    searchStatus = `&status=${status}`;
  }

  let searchAgencia = "";
  if (agencia_id) {
    searchAgencia = `&agencia_id=${agencia_id}`;
  }

  return search(
    `${path}/ofx/historico?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}&type=${type}${searchAgencia}${searchStatus}${searchDate}`,
    "GET",
    headers
  );
};

export const vincularAgencia = async ({ empresa_cnpj, body, empresa_id }) => {
  return search(
    `${path}/ofx/vincular-agencia?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}`,
    "PUT",
    headers,
    body
  );
};

export const convertPdf = async (body) => {
  var header = new Headers();
  header.append("content-type", "application/json");
  return search(
    `${pathDocumentsHub}/generic/html-page/convert-pdf`,
    "POST",
    header,
    body
  );
};

export const reopenFileOfxConciliation = async ({ empresa_cnpj, body }) => {
  return search(
    `${path}/ofx/reabrir-arquivo?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
};

export const deleteOfxConciliation = async ({ empresa_cnpj, id }) => {
  return search(
    `${path}/ofx/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
};
